<template>
  <div class="button-container col-sm-12">
    <button
      class="btn btn-secondary form-button"
      @click.stop="$emit('close')"
    >
      {{ $t('common.close') }}
    </button>
    <button
      class="btn btn-danger form-button"
      @click.stop="showModal = true"
    >
      {{ $t('common.remove') }}
    </button>
    <button
      class="btn btn-success form-button"
      :disabled="disabled"
      @click.stop="handleSubmit(url, item, selectedContract)"
    >
      {{ $t('common.save') }}
    </button>
    <base-modal
      v-if="showModal"
      :title="$t('equipments.remove_title')"
      hide-header-close
      @ok="$emit('removalConfirmed', url, item, selectedContract)"
      @close="showModal = false"
    >
      <span class="span-title mb-3">{{ item.external_system_id }}</span>
      {{ $t('equipments.remove_descr') }}
      <div class="row pt-3">
         <span class="span-title">{{ $t('equipments.replace_remove_date_descr') }}</span>
         <div class="col-sm-6 nopads mt-2">
            <equipment-date
                :text="$t('common.end_date')"
                v-model="item.removed_at"
            />
          </div>
      </div>
    </base-modal>
    <base-modal
      v-if="replaceModal"
      :title="$t('equipments.replace_title')"
      :item="item"
      :ok-variant="'success'"
      hide-header-close
      centered
      :cancel-title="$t('common.cancel')"
      @ok="replaceModal = false; $emit('submit', url, item, selectedContract, true)"
      @close="replaceModal = false"
    >
      {{ $t('equipments.replace_descr') }}
      <div class="row pt-3">
          <span class="span-title">{{ $t('equipments.replace_remove_date_descr') }}</span>
          <div class="col-sm-6 nopads mt-2">
              <equipment-date
                :text="$t('common.end_date')"
                v-model="item.removed_at"
              />
          </div>
      </div>
    </base-modal>
  </div>
</template>

<script>
import {equipmentActions} from "@/components/mixins/ConversionMixin";
import BaseModal from "@/components/BaseModal";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'VelhoEditorButtons',
    components: {EquipmentDate, BaseModal},
    props: {
        disabled: {
            type: Boolean,
            default() {
                return false
            }
        },
        url: {
            type: String,
            default: null
        },
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            showModal: false,
            replaceModal: false
        }
    },
    methods: {
        handleSubmit(url, item, selectedContract) {
            if(item.actions.includes(equipmentActions.REPLACE) || item.linked_equipment.some(x => x.hasOwnProperty("actions") && !!x.actions.find(y => y.value === equipmentActions.REPLACE))) {
                this.replaceModal = true
            } else {
              this.$emit('submit', url, item, selectedContract, false)
            }
        },
    }
}
</script>

<style scoped>
</style>

